export default __webpack_public_path__ + "static/media/mouse-click-left.561a4b0c.svg";